export default function initAlertBox() {
    const alertBox = document.querySelector('#alert-box');
    const alertBoxOverlay = document.querySelector('#alert-box-overlay');

    if (!alertBox) {
        return;
    }

    const alertUid = alertBox.getAttribute('data-alert-uid');

    // setTimeout(() => {
    //     alertBox.classList.remove('is-active');
    //     alertBoxOverlay.classList.remove('is-active');
    //     alertBox.setAttribute('aria-hidden', 'true');
    //     alertBox.setAttribute('tabindex', '-1');
    // }, 10000);

    function closeAndAknowledgeAlertBox() {
        alertBox.classList.remove('is-active');
        alertBoxOverlay.classList.remove('is-active');
        alertBox.setAttribute('aria-hidden', 'true');
        localStorage.setItem('cmv-alert-box', alertUid);

        const tabIndexElements = alertBox.querySelectorAll('[tabindex="0"]');
        tabIndexElements.forEach((el) => {
            el.setAttribute('tabindex', '-1');
        });

        document.body.classList.remove('is-fixed');

        setTimeout(() => {
            alertBox.remove();
            alertBoxOverlay.remove();
        }, 500);
    }

    const alertBoxClose = alertBox.querySelector('.close');
    const alertBoxCta = alertBox.querySelector('a');

    // Localstorage cmv-alert-box
    if (localStorage.getItem('cmv-alert-box') === alertUid) {
        // closeAndAknowledgeAlertBox();
        // return;
    } else {
        // Open alertBox
        alertBox.classList.add('is-active');
        alertBoxOverlay.classList.add('is-active');
        alertBox.setAttribute('aria-hidden', 'false');

        // Prevent body from scrolling
        document.body.classList.add('is-fixed');

        const tabIndexElements = alertBox.querySelectorAll('[tabindex="-1"]');
        tabIndexElements.forEach((el) => {
            el.setAttribute('tabindex', '0');
        });
        tabIndexElements[0].focus();

        // Keep focus inside modal
        alertBox.addEventListener('keydown', (e) => {
            const focusableElements = alertBox.querySelectorAll('[tabindex]');

            const firstFocusableElement = focusableElements[0];
            const lastFocusableElement = focusableElements[focusableElements.length - 1];

            const isTabPressed = e.key === 'Tab' || e.keyCode === 9;

            if (!isTabPressed) {
                return;
            }

            if (e.shiftKey) {
                if (document.activeElement === firstFocusableElement) {
                    lastFocusableElement.focus();
                    e.preventDefault();
                }
            } else {
                if (document.activeElement === lastFocusableElement) {
                    firstFocusableElement.focus();
                    e.preventDefault();
                }
            }
        });

        // Close modal on ESC key
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                closeAndAknowledgeAlertBox();
            }
        });
    }

    // Close actions
    alertBoxClose.addEventListener('click', (e) => {
        e.preventDefault();
        closeAndAknowledgeAlertBox();
    });

    if (alertBoxCta) {
        alertBoxCta.addEventListener('click', () => {
            closeAndAknowledgeAlertBox();
        });
    }

    alertBoxOverlay.addEventListener('click', () => {
        closeAndAknowledgeAlertBox();
    });
}
